import * as React from "react";

import { cn } from "@/lib/utils";

type SectionProps = {
  as?: React.ElementType;
  tone?:
    | "default"
    | "muted"
    | "dark"
    | "purple"
    | "rose"
    | "green"
    | "yellow"
    | "blue"
    | "white";
  spacing?: "sm" | "md" | "lg" | "xl";
  className?: string;
  id?: string;
  ariaLabel?: string;
  children: React.ReactNode;
};

const toneStyles: Record<NonNullable<SectionProps["tone"]>, string> = {
  default: "bg-background text-foreground",
  muted: "bg-muted text-foreground",
  dark: "bg-clarus-dark text-white",
  purple: "bg-clarus-purple text-clarus-dark",
  rose: "bg-clarus-rose text-clarus-dark",
  green: "bg-clarus-green text-clarus-dark",
  yellow: "bg-clarus-yellow text-clarus-dark",
  blue: "bg-clarus-blue text-clarus-dark",
  white: "bg-white text-clarus-dark",
};

const spacingStyles: Record<NonNullable<SectionProps["spacing"]>, string> = {
  sm: "py-12 md:py-16",
  md: "py-16 md:py-20",
  lg: "py-20 md:py-28",
  xl: "py-24 md:py-36",
};

export function Section({
  as: Component = "section",
  tone = "default",
  spacing = "lg",
  className,
  id,
  ariaLabel,
  children,
}: SectionProps) {
  return (
    <Component
      id={id}
      aria-label={ariaLabel}
      className={cn(toneStyles[tone], spacingStyles[spacing], className)}
    >
      {children}
    </Component>
  );
}
